/**
 * Annotation Types and Interfaces
 */

export interface Annotation {
  id?: number;
  documentId: number;
  annotationData: string; // JSON string of Fabric.js canvas data
  version: number;
  createdBy: number;
  createdAt: string;
  lastModifiedBy: number;
  lastModifiedAt: string;
}

export interface AnnotationData {
  version: string;
  objects: any[]; // Fabric.js objects
}

export enum AnnotationTool {
  SELECT = 'select',
  FREEHAND = 'freehand',
  RECTANGLE = 'rectangle',
  CIRCLE = 'circle',
  ARROW = 'arrow',
  LINE = 'line',
  TEXT = 'text',
  HIGHLIGHT = 'highlight',
  ERASER = 'eraser',
  MEASURE_DISTANCE = 'measure-distance',
  MEASURE_AREA = 'measure-area',
  MEASURE_POLYGON = 'measure-polygon',
}

export interface AnnotationToolSettings {
  strokeColor: string;
  fillColor: string;
  strokeWidth: number;
  fontSize: number;
  opacity: number;
  scale?: string; // e.g., '1:100', '1:50'
  scaleRatio?: number; // Calculated ratio (e.g., 100 for 1:100)
  measurementUnit?: 'meters' | 'feet';
  showGrid?: boolean; // Toggle grid visibility
  gridSize?: number; // Grid cell size in pixels
}

export interface AnnotationState {
  tool: AnnotationTool;
  settings: AnnotationToolSettings;
  zoom: number;
  canUndo: boolean;
  canRedo: boolean;
  isDirty: boolean;
}

export interface ExportOptions {
  format: 'png' | 'jpg' | 'pdf';
  quality: number;
  scale: number;
}

export interface PDFPageInfo {
  pageNumber: number;
  width: number;
  height: number;
  scale: number;
}

export interface MultiPageAnnotation {
  pageNumber: number;
  annotationData: string; // JSON string of Fabric.js canvas data for this page
}

export interface AnnotationListItem {
  id: string;
  type: AnnotationTool;
  pageNumber?: number;
  timestamp: Date;
  author?: string;
  text?: string;
  color: string;
  position: { x: number; y: number };
  layerId?: string; // Layer this annotation belongs to
}

/**
 * Layer System Interfaces
 */

export interface AnnotationLayer {
  id: string;
  name: string;
  visible: boolean;
  locked: boolean;
  color: string; // Color-coding for layer identification
  opacity: number; // Layer opacity (0-1)
  order: number; // Layer z-index order (higher = on top)
  createdAt: Date;
  objectCount?: number; // Number of objects in this layer
}

export interface LayerSettings {
  activeLayerId: string | null;
  layers: AnnotationLayer[];
}
